import { Storage } from 'aws-amplify';
import awsConfig from '../config/aws';

async function uploadProfileImg(request) {
  console.log('mediaServices.uploadProfileImg(): ', request);
  const img = await fetch(request.payload.img.picture.uri);
  const blob = await img.blob();
  await Storage.put(request.payload.img.userid, blob);
  const imgURL = `https://${awsConfig.bucket}.s3.amazonaws.com/public/${request.payload.img.userid}`;
  return imgURL;
}

const mediaServices = {
  uploadProfileImg,
};

export default mediaServices;
